import React, { Component, Fragment } from "react";

import ActionItem from "./ActionItem";

class ActionList extends Component {
  onClick(id, url) {
    const { push, actionCenterClick } = this.props;
    actionCenterClick(id, push(url));
  }

  render() {
    if(this.props.items.length === 0) return <div />;

    return (
      <Fragment>
        <section className="cardTitle _leftAligned">Action Needed</section>
        {
          this.props.items.map((item) => {
            return (
              <ActionItem
                key={item.id}
                item={item}
                onClick={(url) => { this.onClick(item.id, url) }}
              />
            );
          })
        }
      </Fragment>
    );
  };
}

export default ActionList;



// WEBPACK FOOTER //
// ./src/features/notifications/components/ActionList.js